module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"total":"Total","order-deleted":"Order deleted","failed-delete-order":"Failed to delete order","delete-order":"Delete Order"}}')
  delete Component.options._Ctor
}
